import AddedSportsModifier from './AddedSportsModifier';
import AddedLeaguesModifier from './AddedLeaguesModifier';
import AddedMatchesModifier from './AddedMatchesModifier';
import AddedScoresModifier from './AddedScoresModifier';

import AddedOutcomesModifier from './AddedOutcomesModifier';
import AddedRatesModifier from './AddedRatesModifier';

import ChangedSportsModifier from './ChangedSportsModifier';
import ChangedLeaguesModifier from './ChangedLeaguesModifier';
import ChangedMatchesModifier from './ChangedMatchesModifier';
import ChangedScoresModifier from './ChangedScoresModifier';
import ChangedOutcomesModifier from './ChangedOutcomesModifier';

import RemovedSportsModifier from './RemovedSportsModifier';
import RemovedLeaguesModifier from './RemovedLeaguesModifier';
import RemovedMatchesModifier from './RemovedMatchesModifier';
import RemovedScoresModifier from './RemovedScoresModifier';

import RemovedOutcomesModifier from './RemovedOutcomesModifier';

export default class ExpandKeyModifier {
    constructor(repository, modifiers) {
        this._modifiers = modifiers || [
                new AddedSportsModifier(repository),
                new AddedLeaguesModifier(repository),
                new AddedMatchesModifier(repository),
                new AddedScoresModifier(repository),

                new AddedOutcomesModifier(repository),
                new AddedRatesModifier(repository),

                new ChangedSportsModifier(repository),
                new ChangedLeaguesModifier(repository),
                new ChangedMatchesModifier(repository),
                new ChangedOutcomesModifier(repository),
                new ChangedScoresModifier(repository),

                new RemovedOutcomesModifier(repository),
                new RemovedScoresModifier(repository),
                new RemovedMatchesModifier(repository),
                new RemovedLeaguesModifier(repository),
                new RemovedSportsModifier(repository)
            ];
    }

    modify(content) {
        for (let i = 0; i < this._modifiers.length; i++) {
            const modifier = this._modifiers[i];

            modifier.modify(content);
        }
    }
}



// WEBPACK FOOTER //
// ./js/repositories/modifier/ExpandKeyModifier.js